import { Modal, message } from "antd";
import { useState } from "react";

function DeleteChatModal({ open, onConfirm, onCancel }) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      message.success('Chat Deleted!');
    } catch (error) {
      message.error('Failed to delete the chat.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Delete Chat"
      open={open}
      onOk={handleConfirm}
      onCancel={onCancel}
      okText="Yes, Delete"
      cancelText="No"
      okButtonProps={{ danger: true, loading }}
      cancelButtonProps={{ disabled: loading }}
    >
      <p>Are you sure you want to delete this chat?</p>
    </Modal>
  );
}

export default DeleteChatModal;